import React from "react";
import { Grid, TextField, Button, FormControlLabel, Checkbox } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
    merchantCompanyBankAccountNumber: Yup.string()
        .required("Bank Account Number is required")
        .matches(/^\d{9,18}$/, "Bank Account Number should be between 9 to 18 digits"),  // Optional validation for account number format

    merchantBankIfscCode: Yup.string()
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code")
        .required("IFSC Code is required"),

    merchantBankAccountName: Yup.string()
        .required("Account Holder Name is required")
        .min(3, "Account Holder Name should be at least 3 characters"),

    cancelledChequeImages: Yup.boolean()
        .oneOf([true], "You must agree to upload cancelled cheque images")
        .required("Cancelled Cheque Images is required"),
});

const BankDetails = ({ initialValues, onNext, onBack }) => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => onNext(values)}
        >
            {({ values, errors, touched, handleChange }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Bank Account Number"
                                name="merchantCompanyBankAccountNumber"
                                value={values.merchantCompanyBankAccountNumber}
                                onChange={handleChange}
                                error={Boolean(errors.merchantCompanyBankAccountNumber && touched.merchantCompanyBankAccountNumber)}
                                helperText={touched.merchantCompanyBankAccountNumber && errors.merchantCompanyBankAccountNumber}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="IFSC Code"
                                name="merchantBankIfscCode"
                                value={values.merchantBankIfscCode}
                                onChange={handleChange}
                                error={Boolean(errors.merchantBankIfscCode && touched.merchantBankIfscCode)}
                                helperText={touched.merchantBankIfscCode && errors.merchantBankIfscCode}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Account Holder Name"
                                name="merchantBankAccountName"
                                value={values.merchantBankAccountName}
                                onChange={handleChange}
                                error={Boolean(errors.merchantBankAccountName && touched.merchantBankAccountName)}
                                helperText={touched.merchantBankAccountName && errors.merchantBankAccountName}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={values.cancelledChequeImages}
                                        onChange={handleChange}
                                        name="cancelledChequeImages"
                                        color="primary"
                                    />
                                }
                                label="I agree to upload cancelled cheque images"
                            />
                            {errors.cancelledChequeImages && touched.cancelledChequeImages && (
                                <div style={{ color: 'red', fontSize: '12px' }}>
                                    {errors.cancelledChequeImages}
                                </div>
                            )}
                        </Grid>
                    </Grid>
                    <Button variant="contained" color="secondary" sx={{ mt: 2, mr: 2 }} onClick={onBack}>
                        Back
                    </Button>
                    <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                        Next
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default BankDetails;
